import React, { useState } from "react";
import style from "./styles/ModalSubmenuItem.module.scss";
import IconAndText from "../../icons/IconAndText";
import { UrlService } from "../../../services";
import { Link } from "../..";
import { v4 as uuidv4 } from "uuid";
import { ModalMenuItem } from "./ModalMenuItem";

export interface ModalSubmenuItemProps extends React.PropsWithChildren {
  item: ModalMenuItem;
  handleClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

export function ModalSubmenuItem(props: ModalSubmenuItemProps) {
  const {
    label,
    url,
    params,
    icon,
    activeMatch,
    activeMatchExact,
    innerItems,
    clickHandler,
    ifActive,
  } = props.item;

  const [showSubMenu, setShowSubMenu] = useState(false);

  let extraClasses = "";
  if (ifActive === "active") {
    extraClasses += ifActive === "active"
      ? "active border-bottom border-primary border-2"
      : "";
  }

  let rootComponent: React.JSX.Element;

  const handleBlur = (e: React.FocusEvent<HTMLElement>) => {
    //The timeout is needed to allow the navigation event to fire first
    setTimeout(() => {
      setShowSubMenu(false);
    }, 200);
  };

  if (innerItems) {
    extraClasses += " p-0 ";
    rootComponent = (
      <div onBlur={handleBlur}>
        <button
          className="btn dropdown-toggle"
          type="button"
          id={uuidv4()}
          title={label}
          onClick={(e) => {
            e.preventDefault();
            setShowSubMenu(!showSubMenu);
          }}
          data-bs-toggle="dropdown"
          aria-expanded="true"
        >
          <IconAndText iconName={icon ?? ""} text={label}></IconAndText>
        </button>
        <ul
          className={`dropdown-menu bg-light ${
            showSubMenu ? "d-block" : ""
          }`}
        >
          {innerItems.map((item) => (
            <ModalSubmenuItem key={uuidv4()} item={item}></ModalSubmenuItem>
          ))}
        </ul>
      </div>
    );
  } else {
    rootComponent = (
      <Link
        url={!clickHandler ? url : "#"}
        params={params}
        className="btn"
      >
        <IconAndText iconName={icon ?? ""} text={label}></IconAndText>
      </Link>
    );
  }

  return (
    <li
      className={`${style.submenuitem} nav-item rounded-0 ${extraClasses} ${ifActive}`} onClick={clickHandler}
    >
      {rootComponent}
    </li>
  );
}

export default ModalSubmenuItem;

